import { render } from "./CreateAccountPage.vue?vue&type=template&id=7856fd4c&scoped=true"
import script from "./CreateAccountPage.vue?vue&type=script&lang=js"
export * from "./CreateAccountPage.vue?vue&type=script&lang=js"

import "./CreateAccountPage.vue?vue&type=style&index=0&id=7856fd4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7856fd4c"]])

export default __exports__